export default {"src":"/_next/static/media/smiley-sad.8b961ace.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};